$(document).ready(function() {
    // video-play
    // $(document).on("click", "body:not(.client-view-page) .play-btn", function() {
    //     $(this).fadeOut(function() {
    //         $(this).closest(".video-wrapper").find('video').attr('controls', true).trigger('play');
    //     })
    // });

    //video pause
    $("video").on("pause", function(e) {
        $(this).attr('controls', false).closest(".video-wrapper").find(".play-btn").fadeIn();
    });

    /*Open-video detail*/
    $(document).on("click", ".btn-review, .video-thumb i.circle-icon", function() {
        $(this).closest(".table-row").find(".video-wrapper").addClass("open-video");
        $("body").addClass("overlay-bg");
    });

    //approve button click
    $(document).on("click", ".btn-approve", function() {
        $(".open-video video").trigger('pause');
        $(".video-wrapper").removeClass("open-video");
        $("body").removeClass("overlay-bg");
        $(".slideout-video").removeClass('video-playing');
    });

    //reject button click
    $(document).on("click", ".btn-reject", function() {
        $(".open-video video").trigger('pause');
        $(".video-wrapper").removeClass("open-video");
        $("body").removeClass("overlay-bg");
        $(".slideout-video").removeClass('video-playing');
    });

    //overlay click close video wrap
    $(document).on("click touchstart", ".overlay:not(.video-wrapper), .overlay-search:not(.video-wrapper)", function() {
        $(".open-video video").trigger('pause');
        $(".video-wrapper").removeClass("open-video");
        $("body").removeClass("overlay-bg");
        $(".slideout-video").removeClass('video-playing');
    });

    //video revision request
    $(document).on("click", ".btn-request", function() {
        $(".action-block").addClass("open-request-block");
        $(".reject-block").find(".btn-action").click(function() {
            $(".approve-block").show();
            $(".action-block").removeClass("open-request-block");
        });

        $(".reject-block").find(".btn-reject").on("click", function() {
            $(".video-wrapper").removeClass("open-video");
            $("body").removeClass("overlay-bg");
            $(".action-block").removeClass("open-request-block");
            $(".slideout-video").removeClass('video-playing');
        });
    });
});